import { useTranslation } from "react-i18next";

import { DuplicateImageUrl } from "components/Icons";

import { ErrorScreen, ErrorScreenImagePosition } from "../ErrorScreen";

const AlreadyLinked = () => {
  const { t } = useTranslation();

  return (
    <ErrorScreen
      imagePosition={ErrorScreenImagePosition.Top}
      title={t("aws.already_linked_title")}
      image={<DuplicateImageUrl />}
    />
  );
};

export default AlreadyLinked;
